import { useField } from 'formik';
import { TextField } from '@mui/material';

import {
  CheckboxFormField,
  FormChoiceResponse,
  FormChoiceResponseType,
  FORM_OTHER_OPTION_VALUE,
} from 'types';

import { CheckboxField } from '../fields';

export const FormCheckboxField = ({
  id,
  label,
  options,
  required,
}: CheckboxFormField) => {
  const [field, , helpers] = useField<FormChoiceResponse[]>(id);
  const responses = Array.isArray(field.value) ? field.value : [];
  const otherResponse = responses.find(
    (response) => response.type === FormChoiceResponseType.OTHER
  );
  const displayValue = responses.map((response) =>
    response.type === FormChoiceResponseType.OTHER
      ? FORM_OTHER_OPTION_VALUE
      : response.value
  );
  const checkboxOptions = [
    ...(options?.options ?? []).map((option) => ({
      label: option,
      value: option,
    })),
    ...(options?.allowOther
      ? [{ label: 'Other', value: FORM_OTHER_OPTION_VALUE }]
      : []),
  ];

  return (
    <CheckboxField
      name={id}
      label={label}
      required={required}
      options={checkboxOptions}
      displayValue={displayValue}
      mapValue={(values) =>
        values.map((value) =>
          value === FORM_OTHER_OPTION_VALUE
            ? {
                value: otherResponse?.value ?? '',
                type: FormChoiceResponseType.OTHER,
              }
            : { value, type: FormChoiceResponseType.OPTION }
        )
      }
    >
      {options?.allowOther && otherResponse && (
        <TextField
          fullWidth
          label="Other"
          className="mt-2"
          value={otherResponse.value}
          placeholder="Enter another response"
          onBlur={() => helpers.setTouched(true, true)}
          onChange={(event) =>
            helpers.setValue(
              responses.map((response) =>
                response.type === FormChoiceResponseType.OTHER
                  ? { ...response, value: event.target.value }
                  : response
              ),
              true
            )
          }
        />
      )}
    </CheckboxField>
  );
};
